import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  logo: {
    width: "180px",
    maxWidth: "100%",
    marginBottom: theme.spacing(2),
  },
  text: {
    marginBottom: theme.spacing(4),
  },
}));

export default () => {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <img
        className={styles.logo}
        src="logo/layapp-title-1000x300.png"
        alt="Logo"
      />

      <Typography className={styles.text} variant="body1">
        お探しのページは見つかりませんでした
      </Typography>

      <Button variant="contained" color="primary" component={Link} to="/">
        トップページへ
      </Button>
    </div>
  );
};
